import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SendContactCollectorMessagesJoyJsonMutationVariables = Types.Exact<{
  data: Types.SendJoyJsonMessagesByPersonIdsInput;
}>;

export type SendContactCollectorMessagesJoyJsonMutation = {
  __typename?: 'Mutation';
  sendJoyJsonMessagesByPersonIds: {
    __typename?: 'SendMessageBatchResult';
    messageBatchId: string;
    quarantined: boolean;
    sentEmails: number;
    sentSms: number;
    skippedEmails: number;
    skippedSms: number;
  };
};

export type SendTestContactCollectorMessageJoyJsonMutationVariables = Types.Exact<{
  data: Types.SendTestJoyJsonMessageEmailInput;
}>;

export type SendTestContactCollectorMessageJoyJsonMutation = { __typename?: 'Mutation'; sendTestJoyJsonMessageEmail?: any | null };

export type GetMessagingTierQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetMessagingTierQuery = {
  __typename?: 'Query';
  getMessagingSettingsByEventId?: { __typename?: 'MessagingSettings'; id: string; messagingTier?: Types.MessagingTier | null } | null;
};

export const SendContactCollectorMessagesJoyJsonDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendContactCollectorMessagesJoyJson' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendJoyJsonMessagesByPersonIdsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendJoyJsonMessagesByPersonIds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quarantined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentEmails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentSms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skippedEmails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skippedSms' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendContactCollectorMessagesJoyJsonMutationFn = Apollo.MutationFunction<
  SendContactCollectorMessagesJoyJsonMutation,
  SendContactCollectorMessagesJoyJsonMutationVariables
>;

/**
 * __useSendContactCollectorMessagesJoyJsonMutation__
 *
 * To run a mutation, you first call `useSendContactCollectorMessagesJoyJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactCollectorMessagesJoyJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactCollectorMessagesJoyJsonMutation, { data, loading, error }] = useSendContactCollectorMessagesJoyJsonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendContactCollectorMessagesJoyJsonMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendContactCollectorMessagesJoyJsonMutation, SendContactCollectorMessagesJoyJsonMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendContactCollectorMessagesJoyJsonMutation, SendContactCollectorMessagesJoyJsonMutationVariables>(
    SendContactCollectorMessagesJoyJsonDocument,
    baseOptions,
  );
}
export type SendContactCollectorMessagesJoyJsonMutationHookResult = ReturnType<typeof useSendContactCollectorMessagesJoyJsonMutation>;
export type SendContactCollectorMessagesJoyJsonMutationResult = Apollo.MutationResult<SendContactCollectorMessagesJoyJsonMutation>;
export type SendContactCollectorMessagesJoyJsonMutationOptions = Apollo.BaseMutationOptions<
  SendContactCollectorMessagesJoyJsonMutation,
  SendContactCollectorMessagesJoyJsonMutationVariables
>;
export const SendTestContactCollectorMessageJoyJsonDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendTestContactCollectorMessageJoyJson' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendTestJoyJsonMessageEmailInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTestJoyJsonMessageEmail' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendTestContactCollectorMessageJoyJsonMutationFn = Apollo.MutationFunction<
  SendTestContactCollectorMessageJoyJsonMutation,
  SendTestContactCollectorMessageJoyJsonMutationVariables
>;

/**
 * __useSendTestContactCollectorMessageJoyJsonMutation__
 *
 * To run a mutation, you first call `useSendTestContactCollectorMessageJoyJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestContactCollectorMessageJoyJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestContactCollectorMessageJoyJsonMutation, { data, loading, error }] = useSendTestContactCollectorMessageJoyJsonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendTestContactCollectorMessageJoyJsonMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestContactCollectorMessageJoyJsonMutation, SendTestContactCollectorMessageJoyJsonMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendTestContactCollectorMessageJoyJsonMutation, SendTestContactCollectorMessageJoyJsonMutationVariables>(
    SendTestContactCollectorMessageJoyJsonDocument,
    baseOptions,
  );
}
export type SendTestContactCollectorMessageJoyJsonMutationHookResult = ReturnType<typeof useSendTestContactCollectorMessageJoyJsonMutation>;
export type SendTestContactCollectorMessageJoyJsonMutationResult = Apollo.MutationResult<SendTestContactCollectorMessageJoyJsonMutation>;
export type SendTestContactCollectorMessageJoyJsonMutationOptions = Apollo.BaseMutationOptions<
  SendTestContactCollectorMessageJoyJsonMutation,
  SendTestContactCollectorMessageJoyJsonMutationVariables
>;
export const GetMessagingTierDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMessagingTier' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMessagingSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messagingTier' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMessagingTierQuery__
 *
 * To run a query within a React component, call `useGetMessagingTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingTierQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingTierQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingTierQuery, GetMessagingTierQueryVariables>) {
  return ApolloReactHooks.useQuery<GetMessagingTierQuery, GetMessagingTierQueryVariables>(GetMessagingTierDocument, baseOptions);
}
export function useGetMessagingTierLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingTierQuery, GetMessagingTierQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetMessagingTierQuery, GetMessagingTierQueryVariables>(GetMessagingTierDocument, baseOptions);
}
export type GetMessagingTierQueryHookResult = ReturnType<typeof useGetMessagingTierQuery>;
export type GetMessagingTierLazyQueryHookResult = ReturnType<typeof useGetMessagingTierLazyQuery>;
export type GetMessagingTierQueryResult = Apollo.QueryResult<GetMessagingTierQuery, GetMessagingTierQueryVariables>;
